document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll(
    '.fade-up, .fade-down, .fade-left, .fade-right'
  );

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      //small delay for a smoother appearance
      setTimeout(() => {
        entry.target.classList.add('is-visible');
      }, 100);

      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -10% 0px'
  });

  elements.forEach(el => observer.observe(el));
});